// Copyright © 2023 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react'
import { defineMessages } from 'react-intl'

import Modal from '@ttn-lw/components/modal'
import Link from '@ttn-lw/components/link'

import { eraseCookie } from '@ttn-lw/lib/cookie'

const m = defineMessages({
  modalTitle: 'The Claim App has been removed',
  modalMessage:
    'The Claim App and in-cluster claiming has been removed in version 3.25.2. You can use the regular device registration flow in the Console, which includes claiming if applicable, or use the claiming feature of the CLI. For more information, please refer to the <Link>Device Claiming</Link> documentation.',
  buttonMessage: 'Close and use Console',
})

const handleCompleteClick = () => {
  eraseCookie('claim_deprecated')
}

const ClaimDeprecationModal = () => (
  <Modal
    approval={false}
    buttonMessage={m.buttonMessage}
    message={{
      ...m.modalMessage,
      values: {
        Link: val => (
          <Link.DocLink path="/devices/device-claiming" secondary>
            {val}
          </Link.DocLink>
        ),
      },
    }}
    title={m.modalTitle}
    onComplete={handleCompleteClick}
    approveButtonProps={{ icon: 'check' }}
    handleClosure
  />
)

export default ClaimDeprecationModal
